import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export default () => {
  const { t } = useI18n();

  const schema = yup.object().shape({
    delivery_destinations: yup
      .array()
      .min(1, t('sites.singleSite.dropoffLocations.timeslots.minimumLocationSelect'))
      .required(t('sites.singleSite.dropoffLocations.timeslots.minimumLocationSelect')),
  });

  return {
    schema,
  };
};
